export const GlobalPostService = Object.freeze({
  Plus: '252801',
  StandardIntl: '252807',
});

export const GlobalPostName = 'GlobalPost';
